<template>
  <BaseElInput
    v-model="syncModel"
    :placeholder="placeholder"
    v-bind="$attrs"
    clearable
    @clear="onClear"
    @keypress.enter.native="onEnter"
  >
    <i
      slot="suffix"
      class="el-input__icon el-icon-search"
      @click="onEnter"
    />
  </BaseElInput>
</template>

<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'SearchTextInput',
  props: {
    placeholder: { type: String, default: '輸入名稱' },
    value: String,
  },
  emits: ['refresh'],
  setup (props, { emit }) {
    // 使用 computed 替代 useVModel，同时 emit input (兼容 v-model)
    // 和 update:value (兼容 .sync)，避免与 BobProPage 的 v-model 事件不匹配
    const syncModel = computed({
      get: () => props.value,
      set: (val) => {
        emit('input', val)
        emit('update:value', val)
      },
    })
    const onClear = () => {
      emit('refresh', true)
      emit('clear')
    }
    const onEnter = () => {
      emit('update', syncModel.value)
      emit('refresh', true)
    }
    return { syncModel, onClear, onEnter }
  },
})
</script>

<style lang="postcss" scoped>

</style>
